import { Injectable } from "@angular/core";

declare var ga: Function;

@Injectable()
export class AnalyticsService {
    public static pageView(pagerout: string) {
        ga('set', 'page', pagerout);
        ga('send', 'pageview');
    }

    public static sendEvent(category: string, action: string) {
        // ga('send', 'pageview');
        ga('send', 'event', category, action);
    }
}



// WEBPACK FOOTER //
// ./src/app/client-core/services/analytics-service.ts